const Button = {
  baseStyle: {
    borderRadius: '8px',
    color: 'brand.white',
    _focus: {
      ring: 'none',
    },
    _hover: {
      textDecoration: 'none',
    },
  },
  variants: {
    primary: {
      px: '24px',
      py: '8px',
      color: 'brand.white',
      backgroundColor: 'brand.primary',
      borderBottom: 'solid 3px #58d7b1',
      _hover: {
        backgroundColor: 'brand.primary',
        filter: 'brightness(85%)',
      },
      _active: {
        backgroundColor: 'brand.primary',
      },
    },
    outlined: {
      px: '16px',
      py: '8px',
      color: 'brand.black',
      backgroundColor: 'transparent',
      border: '2px solid',
      borderColor: 'brand.black',
      _hover: {
        backgroundColor: 'brand.black',
        borderColor: 'brand.black',
        color: 'brand.white',
      },
      _active: {
        backgroundColor: 'brand.black',
        borderColor: 'brand.black',
        color: 'brand.white',
      },
      _disabled: {
        alpha: 0.4,
      },
    },
    menu: {
      width: '100%',
      height: '130px',
      backgroundColor: 'white',
      border: '1px solid',
      borderColor: '#e0e0e0',
      boxShadow: '0 20px 20px rgba(0, 0, 0, .08)',
      textAlign: 'center',
      color: 'brand.textColor',
      _disabled: {
        alpha: 0.4,
      },
      _selected: {
        color: 'brand.primary',
      },
    },
    footerLink: {
      fontSize: {base: 13, md: 16},
      color: 'brand.white',
      p: 0,
      _hover: {
        textDecoration: 'none',
        opacity: 0.7,
      },
      _active: {
        opacity: 0.5,
      },
    },
    category: {
      color: 'brand.textColor',
      px: '15px',
      py: '5px',
      borderRadius: '6px',
      _hover: {
        color: 'brand.white',
        backgroundColor: 'brand.primary',
      },
      _active: {
        color: 'brand.white',
        backgroundColor: 'brand.primary',
      },
    },
    ghost: {
      color: 'brand.textColor',
      p: 0,
      _hover: {
        backgroundColor: 'transparent',
      },
    },
    profileTabLink: {
      color: 'brand.textColor',
      padding: '9px 0',
      fontSize: '16px',
      borderBottom: 'solid 2px',
      borderColor: 'transparent',
      borderRadius: 'none',
      _hover: {
        color: 'brand.primary',
      },
      _active: {
        color: 'brand.primary',
        fontWeight: 'bold',
        borderColor: 'brand.primary',
      },
    },
    hub: {
      padding: '2rem',
      color: 'brand.white',
      fontSize: {base: '1.25rem'},
      borderBottom: 'solid 3px',
      _hover: {
        filter: 'brightness(85%)',
      },
    },
    'menu-sidebar': {
      color: 'brand.textColor',
      height: '48px',
      fontSize: '16px',
      borderRadius: 'none',
      _hover: {
        color: 'brand.primary',
      },
      _active: {
        color: 'brand.primary',
      },
      _disabled: {
        color: 'brand.gray400',
      },
    },
  },
}
export default Button
